import * as React from 'react';
import qs from 'qs';

export function queryStringToObject(): any {
  return qs.parse(window.location.search.slice(1));
}

/**
 * @deprecated Use a hook for this instead
 */
export const withQueryParams =
  (parseQueryParams: (a: any) => any) =>
  (
    Inner: React.ComponentType<any>,
  ): React.ComponentType<Omit<any, keyof any>> => {
    return props => (
      <Inner {...parseQueryParams(queryStringToObject())} {...props} />
    );
  };
